export const inp = "w-full bg-[#0B0A08] border border-[#262421] px-3 py-2 text-sm outline-none focus:border-[#C49A6C] transition-colors text-[#F2EBE1]";
export const lbl = "text-[10px] uppercase tracking-[0.15em] text-[#8A857D]";

export const emptyProduct = {
  slug: "", name_en: "", name_ar: "", short_en: "", short_ar: "", description_en: "", description_ar: "",
  perfumer_en: "", perfumer_ar: "", details_en: "", details_ar: "", shipping_en: "", shipping_ar: "",
  size: "30 ML", concentration: "", parfum_type: "Extrait de Parfum", notes_en: [], notes_ar: [],
  olfactive_family_en: "", olfactive_family_ar: "", scent_profile_en: "", scent_profile_ar: "",
  ingredients_en: "", ingredients_ar: "", natural_percentage: null,
  accords: [],
  videos_title_en: "The Making of Latte Oud", videos_title_ar: "مراحل تصميم عطر لاتيه عود",
  price: 0, currency: "AED", stock: 0, status: "available", limited_qty: null, images: [], videos: [], featured: false,
};
